import { mixpanel, snowplow } from 'common/helpers/analytics'


type Message = {
  [key: string]: any
}

type NavItem = {
  to?: string
  toOLD?: string
  href?: string
  onClick?: (a?: any) => any
  title?: Message
  userLoggedIn?: string
  redirect?: string
}

type Events = {
  mixpanelEvent?: string
  snowplowEvent?: string
}

type Params = {
  link: string
  title: string
  userLoggedIn?: string
}

const getTrackingEventToNavItem = <T extends NavItem>(navItem: T, events: Events): NavItem => {
  const { to, toOLD, href, onClick, title, userLoggedIn, ...rest } = navItem
  const { mixpanelEvent, snowplowEvent } = events

  return {
    title,
    to,
    toOLD,
    href,
    ...rest,
    onClick: (event) => {
      const params: Params = {
        link: to || toOLD || href || navItem.redirect,
        title: title.en || title,
      }

      if (userLoggedIn !== undefined) {
        params.userLoggedIn = userLoggedIn ? 'yes' : 'no'
      }

      if (snowplowEvent) {
        snowplow.track(snowplowEvent, params)
      }

      if (mixpanelEvent) {
        mixpanel.track(mixpanelEvent, params)
      }

      if (typeof onClick === 'function') {
        onClick(event)
      }
    },
  }
}


export default getTrackingEventToNavItem
